import { format } from "date-fns";
export function formatDateForDisplay(date: string): string {
  return format(new Date(date), "yyyy-LL-dd, hh:mm aa");
}